import CreditCardShape from '../definitions/CreditCardShape';
import DEFAULT_CARD_PREFERENCES from '../definitions/DefaultCardPreferences';
import fetchCardInfo from './fetchCardInfo';
import getSumOfObjectValues from './getSumOfObjectValues';


/**
 * This is a convenience wrapper for calling fetchCardInfo(), returning a Promise.
 * @param {object} params - The parameter object.
 * @param {string} params.cardId - Credit card’s id.
 * @param {string} params.languageCode - Two-letter language code, e.g. 'en' or 'fr'.
 * @param {string} params.province - Two-letter province code, e.g. 'ON' or 'BC'.
 * @param {object} params.monthlySpending - User’s monthly spending values.
 * @param {string} params.profileId - profile id from session store
 * @param {string} params.documentId - recent CC journey document id
 * @param {boolean} [params.isUsingApprovalModel=false] - should we use the approval ML model?
 * @returns {Promise<CreditCardShape|null>} - resolves to the credit card info, or null on error
 */
function cardComparisonFetchCardInfo({
    cardId,
    languageCode,
    province,
    monthlySpending,
    profileId,
    documentId,
    isUsingApprovalModel = false,
}) {
    return fetchCardInfo({
        id: cardId,
        languageCode,
        province,
        userPreferences: {
            ...DEFAULT_CARD_PREFERENCES,
            monthlySpending: monthlySpending,
            monthlySpendingAverage: getSumOfObjectValues(monthlySpending),
        },
        profileId,
        documentId,
        isUsingApprovalModel,
    });
}

export default cardComparisonFetchCardInfo;
